/**
 * Collection promo video (sl_promo_video).
 * Muted loop, play while in view, pause off-screen so several short clips
 * don't fight for decode. iOS only autoplays when muted + playsInline.
 */
(function () {
  var SELECTOR = 'video.sl-promo-video';

  function bind(video) {
    if (video.getAttribute('data-sl-bound') === '1') return;
    video.setAttribute('data-sl-bound', '1');
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    function markReady() {
      video.classList.add('is-ready');
    }
    if (video.readyState >= 3) markReady();
    else video.addEventListener('canplay', markReady, { once: true });

    function playSafe() {
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    if (!('IntersectionObserver' in window)) {
      playSafe();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) playSafe();
          else video.pause();
        });
      },
      { root: null, rootMargin: '120px 0px', threshold: 0.15 }
    );
    io.observe(video);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll(SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
